import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=e6a8c518&scoped=true&"
import script from "./TabSelector.vue?vue&type=script&lang=js&"
export * from "./TabSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=e6a8c518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a8c518",
  null
  
)

export default component.exports